export default __webpack_public_path__ + "static/media/Diggers_03.388bca37.png";